// import React from 'react'

const messageConstant = {
  Required: 'Please enter ',
  SelectRequired: 'Please select ',
  Document: {
    DocumentUpload: 'Document Upload',
    DocumentUploaded: 'Document uploaded successfully.',
    DocumentRequired: 'Please select at least one file to upload!',
    NoAccessRights: 'You have no access rights to upload document',
  },
  NotSupportedFileType: 'Not supported file type.',
  MaxFileSize: 'File size should be less than 2 MB',
  ProfileUpdate: 'Profile pic uploaded successfully',
  GreaterthanFormDateToDate: 'To date must be greater than From date',
  NoDataFound: 'No Data Found!',
  DocumentMaxFileSize: 'File size should be less than ',
  ErrorMessage: 'Something went wrong!',
  ErrorSummary: 'Please contact to Admin.',
  ImageExtension: 'Please select .JPG, .JPEG , .PNG',
  APIEnabledSuccess: 'API enabled successfully',
  APIClientSecretUpdated: 'API client secret updated',
  ImportWizard: {
    RequiredCSVfile: 'Please select CSV file.',
    NoRecordFound: 'No record found in selected file.',
    ColumnsNotMapped: 'column(s) are not mapped with TLS fields.',
    ErrorMessage: 'There are some issue with upload, please check downloaded file!',
    DuplicateMapping: 'Selected Mapping have duplicate value.',
    RequiredMapping: 'Please map value for',
  },
  BulkUpload: {
    BulkImageUpload: 'Bulk Image Upload',
    FolderUploadedSuccess: 'Zip uploaded successfully.',
    ValidExtension: 'Please upload valid file',
  },
  FactoryUpload: {
    PurchaseOrder: 'Add Step 1 Documentation',
    PurchaseOrderDiscription:
      'Congratulations! You have successfully uploaded Step 1 documentation. Shortly the Tracemark Team will forward you the alphanumeric codes corresponding to PO-',
    Gold: 'Gold details save successfully',
    GoldDiscription: 'Add Gold',
    Diamond: 'Diamond details save successfully',
    DiamondDiscription: 'Add Diamond',
    Findings: 'Finding details save successfully',
    FindingsDiscription: 'Add Finding',
    Finalprocess: 'Final process details save successfully',
    FinalprocessDiscription: 'Add Final Process',
    fileWarning: 'Please upload the file in given file format',
    AlphanumericCode: 'Alphanumeric Code details save successfully',
    AlphanumericCodeDiscription: 'Add Alphanumeric Code',
    Fileselectvalidation: 'please select only one file.',
    InputTagValidationMessage: 'This filed can only include letters and numbers.',
  },
  ImageRequired: 'Please select image!',
  ArticleTransfer: {
    ValidArticle: 'Please select available articles only.',
    SelectAtLeastOneArticle: 'Please select at least one article to transfer request.',
  },
  DocumentNotFound:
    'It seems like we did not found the document you are requsting to download/view.',
  TransferTransaction: {
    DelTransferAckStatusValidation:
      'It seems like tranfer detail(s) that you are going to delete are already processed!',
  },
  JewelleryArticle: {
    DelArticleStatusValidation:
      'It seems like the article(s) you are going to delete are either sold or in pending transfer',
    JewelleryArticle: 'Jewellery Article(s)',
  },
  CertifiedStone: {
    DelCertifiedStoneStatusValidation:
      'It seems like the certified stone(s) you are going to delete are either sold or in pending transfer',
    CertifiedStone: 'Certified Stone(s)',
  },
  CertifiedStoneAvailable: {
    ValidCertifiedStone: 'Please select available certified stone only.',
  },
  MaxImageResolution: 'Image resolution should not be greater 225 * 85',
  Added: 'Added successfully!',
  PassGenerated:
    'También recibirá su Tracemark ID por email. Por favor, descárguelo utilizando su teléfono móvil para guardarlo automáticamente en formato Passbook.',
  NorightsForPage: 'You have no rights to access this page!',
  OldPasswordIncorrect: 'Your old password is incorrect',
  NewPasswordNotMatch: 'Your new password and confirm password do not match',
  ConfirmPasswordNotMatch: 'Your password and confirm password do not match',
  PasswordRequires:
    'Password requires a minimum of 6 characters, at least 1 capital, 1 lower case letter,1 special character and 1 number',
  File: {
    FileUploaded: 'file uploaded successfully.',
    FileUploadFail: 'file upload failed.',
  },
  UpdateConfirmation: 'Update Confirmation',
  SureToUpdateAll: 'Are you sure you want to update all',
  DeleteConfirmation: 'Delete Confirmation',
  DeleteConfirm: 'Are you sure you want to delete ?',
  AuditConfirmation: 'Audit Confirmation',
  AuditConfirm: 'Are you sure you want to complete audit?',
  OverrideExistingImage: 'This will override existing image.',
  DownloadDocument: 'Download Document',
  DeleteDocument: 'Delete Document',
  TransferRequest: 'Transfer Request',
  DeleteTransferDetail: 'Delete Transfer Detail(s)',
  AcceptTransferRequest: 'Are you sure you want to accept this transfer request ?',
  RejectTransferRequest: 'Are you sure you want to reject this transfer request ?',
  ClientContactDetails: 'Client Contact Details',
  UpdateDocumentDetail: 'Update document detail',
  ResendOneTimePassword: 'Resend One - Time Password',
  VerifyOneTimePassword: 'Verify One - Time Password',
  PersonalizeMomentDetail: 'Personalize Moment Detail',
  ConsumerPersonalizeDetail: 'Consumer Personalize Detail',
  PersonalizeDetailSaved: 'Personalize moment detail saved successfully!',
  OneTimePasswordSent: 'A One - Time Password has been sent to your email',
  EnterOnlyDigits: 'Please enter only digits.',
  ArticleAuditDetails: 'Article Audit Details',
  TransferJewelleryArticle: 'Transfer Jewellery Article(s)',
  ExportDataNotFound: 'No data found to export!',
  PendingTransferModifyArticle:
    'It seems like the article(s) you are going to modify are in pending transfer.',
  SelectAtLeastOne: 'Please select at least one',
  WantToContinue: 'Do you want to continue?',
  ExportDetailsDeleted: 'Export details deleted successfully!',
  PurchaseExport: 'Purchase Export',
  FillDetailBeforeSave: 'Please fill out all details before save.',
  CompleteDetailEdit: 'Please first complete editing of existing detail',
  ExportDetail: 'export detail',
  PurchaseDetail: 'purchase detail',
  ExportDetailsUpdated: 'Export details updated successfully!',
  ExportDetailsSaved: 'Export details saved successfully!',
  CertifiedStoneDetails: 'Certified Stone Details',
  EnterValue: {
    EnterValues: 'Please enter values.',
    EnterProperValue: 'Please enter proper value.',
  },
  InternalCode: {
    AddInternalCode: 'Add Internal Code',
    InternalCodeSaved: 'Internal Code details saved successfully!',
  },
  GenerateDigitalPass: 'Generate Tracemark ID',
  EnterUniqueCode: 'Enter valid unique code',
  PasswordIncorrect: 'Password is incorrect',
  ForgotPassword: 'Forgot Password',
  PasswordNotMatched: 'Password not matched.',
  QRCode: {
    QRCode: 'QR Code',
    NotMapped: 'This QR Code is not mapped.',
    SureToMapQrCode: 'Are you sure you want to map this QR code with',
    MapConfirmation: 'Map Confirmation',
    UnMapConfirmation: 'UnMap Confirmation',
    UnMapSelectedQrCode: 'Are you sure you want to unmap selected qr code(s)?',
    UnMapQrCode: 'Are you sure you want to unmap this qr code?',
    SelectMapped: 'Please select mapped qr codes only.',
  },
  InvalidEmail: 'The input is not valid E-mail!',
  Confirm: 'Please confirm ',
  UserDetailSaved: 'User detail saved successfully, Please add role.',
  CanNotDeleteUser: 'you can not delete this user',
  ResetPassword: 'Reset Password',
  CAnNotDelAdminRole: "You can't delete admin role!",
  TermsAndCondition: 'Please accept the terms and conditions.',

  PassGeneratedHeaderEnglish: 'Your Tracemark ID is downloading',
  PassGeneratedEnglish:
    'We have also sent it to you using the email address provided. Open the attached Tracemark ID on your smartphone to save it to your digital wallet.',

  PassGeneratedHeaderSpanish: 'Descargando Tracemark ID',
  PassGeneratedSpanish:
    'También recibirá su Tracemark ID por email. Por favor, descárguelo utilizando su teléfono móvil para guardarlo automáticamente en formato Passbook.',
  LogoUpload: 'Logo Upload',
  EmailNotificationUpdated: 'Email notification details updated successfully!',
  TenantLogoMaxImageResolution: 'Image resolution should be 90 * 90',

  certificateSuccessEnglish:
    'You will shortly receive an email with the Tracemark certificate for this piece attached, delivered to the address used to register its ownership.',
  certificateSuccessSpanish:
    'En breve recibirás un correo electrónico con el certificado de Tracemark de esta joya adjunto, a la dirección de correo utilizada para registrar su propiedad. ',

  downloadCertificateEnglish: 'Download Certificate',
  downloadCertificateSpanish: 'Descargar certificado',

  notConfiguredCertificateEnglish:
    'If you have not registered this piece’s ownership, please do so above before downloading this piece’s Tracemark certificate.',
  notConfiguredCertificateSpanish:
    'Si no has registrado tu joya, puedes hacerlo directamente desde el panel de trazabilidad, junto al apartado de Tracemark ID.',

  LogoResolution: 'Logo resolution should be 190 x 190',
  clientLogoSize: 'File size should be less than 20 MB',
  panelImageSize: 'File size should be less than 100 KB',
}
export default messageConstant
